(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-nail-size-picker"] && !Shopify.designMode) return;
  try {
    class CustomNailSizePicker extends HTMLElement {
    constructor() {
      super();
      this.productFormId = this.dataset.productFormId;
      this.selects = this.querySelectorAll('.custom-nail-size-picker__select');
      this.form = null;
      this.isCustomSelected = false;
    }

    connectedCallback() {
      this.form = document.getElementById(this.productFormId);
      if (!this.form) return;

      this.setupVariantObserver();
      this.checkInitialVariant();

      // bfcacheから復元された時の対応
      this.handlePageShow = this.handlePageShow.bind(this);
      window.addEventListener('pageshow', this.handlePageShow);
    }

    disconnectedCallback() {
      window.removeEventListener('pageshow', this.handlePageShow);
    }

    handlePageShow(event) {
      if (event.persisted) {
        this.checkInitialVariant();
      }
    }

    setupVariantObserver() {
      const variantSelects = document.querySelectorAll('variant-selects, variant-radios');
      variantSelects.forEach((variantPicker) => {
        variantPicker.addEventListener('change', () => {
          this.checkVariantSelection();
        });
      });

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' || mutation.type === 'childList') {
            this.checkVariantSelection();
          }
        });
      });

      const productInfo = document.querySelector('product-info');
      if (productInfo) {
        observer.observe(productInfo, {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: ['data-selected-variant'],
        });
      }
    }

    checkInitialVariant() {
      this.checkVariantSelection();
    }

    checkVariantSelection() {
      const selectedVariantText = this.getSelectedVariantText();
      const lowerText = selectedVariantText.toLowerCase();
      const isCustom = lowerText.includes('custom') || selectedVariantText.includes('カスタム');

      if (isCustom !== this.isCustomSelected) {
        this.isCustomSelected = isCustom;
        this.toggle(isCustom);
      }
    }

    getSelectedVariantText() {
      const variantSelects = document.querySelectorAll('variant-selects select, variant-radios input:checked');
      let variantText = '';

      variantSelects.forEach((input) => {
        if (input.tagName === 'SELECT') {
          variantText += ' ' + (input.options[input.selectedIndex]?.text || '');
        } else if (input.tagName === 'INPUT') {
          variantText += ' ' + (input.value || '');
        }
      });

      const selectedSwatches = document.querySelectorAll('.product-form__input input:checked');
      selectedSwatches.forEach((input) => {
        variantText += ' ' + (input.value || '');
      });

      return variantText;
    }

    toggle(show) {
      if (show) {
        this.hidden = false;
        this.enableProperties();
      } else {
        this.hidden = true;
        this.disableProperties();
      }
    }

    enableProperties() {
      this.selects.forEach((select) => {
        select.disabled = false;
        select.name = select.dataset.propertyName; // name属性を付与してFormDataに含まれるようにする
      });
    }

    disableProperties() {
      this.selects.forEach((select) => {
        select.disabled = true;
        select.removeAttribute('name'); // name属性を削除してFormDataに含まれないようにする
      });
    }
  }

  if (!customElements.get('custom-nail-size-picker')) {
    customElements.define('custom-nail-size-picker', CustomNailSizePicker);
  }
  } catch(e) { console.error(e); }
})();

})();
